import reduceReducers from 'reduce-reducers';

//Siblings reducers
import loginReducer from './manageLoginReducer';

export default reduceReducers(loginReducer);
